import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCombobox, {
    class: _vm.required ? 'required' : '',
    attrs: {
      "data-cy": "select_icon",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "disabled": _vm.disabled,
      "items": _vm.icons,
      "label": _vm.$i18n_t('Common.icon'),
      "hide-details": _vm.dense,
      "rules": _vm.requiredRule,
      "search-input": _vm.search,
      "no-filter": "",
      "clearable": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "input": function ($event) {
        return _vm.$emit('input', _vm.icon);
      },
      "focus": function ($event) {
        _vm.search = '';
      },
      "blur": function ($event) {
        _vm.search = _vm.icon;
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('div', {
          staticStyle: {
            "width": "30px"
          }
        }, [_c(VIcon, {
          style: !_vm.icon || _vm.icon.trim() === '' ? 'opacity: 0.3' : undefined,
          attrs: {
            "medium": ""
          }
        }, [_vm._v(_vm._s(_vm.faIcon(_vm.icon)))])], 1)];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (data) {
        return [data.item && data.item.trim() !== '' ? _c(VListItemAvatar, [_c(VIcon, [_vm._v(_vm._s(_vm.faIcon(data.item)))])], 1) : _vm._e(), _c(VListItemContent, [_c(VListItemTitle, {
          staticStyle: {
            "margin-left": "3px"
          },
          domProps: {
            "innerHTML": _vm._s(data.item)
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.icon,
      callback: function ($$v) {
        _vm.icon = $$v;
      },
      expression: "icon"
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };